import React from "react";
import { Box, Typography } from "@mui/material";
import { PageTitleProps } from "./types";
import { RefreshButton } from "../RefreshProvider";

function PageTitle(props: PageTitleProps) {
  const { title, subTitle, sx, hideRefresh, actions } = props;
  return (
    <Box
      id="page-title"
      display="flex"
      justifyContent="flex-start"
      flexDirection="column"
      mb={{ xs: 5, sm: 6 }}
      px={{ xs: "auto", md: 0 }}
      mt={0}
      width={"100%"}
      sx={[...(Array.isArray(sx) ? sx : [sx])]}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        {title}

        <Box display="flex" alignItems="center" gap={2}>
          {hideRefresh !== true && (
            <div>
              <RefreshButton />
            </div>
          )}
          {actions}
        </Box>
      </Box>
      {subTitle && (
        <Typography color="grey.70" variant="p3" display="block" mt={1}>
          {subTitle}
        </Typography>
      )}
    </Box>
  );
}

export default PageTitle;
